<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        :title="`Página ${pagina.numero} (${pagina.material})`"
        extraLarge
        ref="Modal"
    >
        <rkm-alert
            v-if="estornoMessage !== null"
            color="warning"
            class="mb-3"
        >
            {{ estornoMessage }}
        </rkm-alert>

        <rkm-table
            :fields="fields"
            :items="linhas"
            responsive
            sort-by="dataMovimentacao"
            class="table-movimentacoes"
        >
            <template
                v-if="transferidoDe !== null"
                #beforeTable
            >
                <div class="text-center table-movimentacoes-header-footer">
                    {{ transferidoDe }}
                </div>
            </template>

            <template #thead-top>
                <rkm-tr>
                    <rkm-th :colspan="isTalidomidaABase ? 1 : 2"></rkm-th>

                    <rkm-th
                        colspan="3"
                        class="text-center"
                    >
                        Movimentação
                    </rkm-th>

                    <rkm-th :colspan="isTalidomidaABase ? 3 : (isTalidomidaEspecifico ? 4 : 1)"></rkm-th>

                    <template v-if="isTalidomidaABase">
                        <rkm-th
                            colspan="2"
                            class="text-center"
                        >
                            Paciente
                        </rkm-th>

                        <rkm-th
                            colspan="2"
                            class="text-center"
                        >
                            Médico
                        </rkm-th>

                        <rkm-th
                            colspan="2"
                            class="text-center"
                        >
                            Doença
                        </rkm-th>

                        <rkm-th></rkm-th>
                    </template>
                </rkm-tr>
            </template>

            <template v-slot:cell(entrada)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(saida)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(perda)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(numeroDocumento)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(numeroNotificacao)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(pacienteDataNascimento)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(pacienteSexo)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(medicoNome)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(medicoCrm)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(cidCodigo)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(cidNome)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(observacoes)="{ value }">{{ value || '-' }}</template>
            <template v-slot:cell(numeroRegistro)="{ value }">{{ value || '-' }}</template>

            <template
                v-if="transferidoPara !== null"
                #afterTable
            >
                <div class="text-center table-movimentacoes-header-footer">
                    {{ transferidoPara }}
                </div>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>
// Others.
import { mapActions, mapGetters } from 'vuex'
import { error, formats } from '@/mixins'
import livroRegistro from '@/enums/cadastro/material/livroRegistro'
import livroRegistroTipo from '@/enums/cadastro/material/livroRegistroTipo'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            const dataMovimentacao = {
                key: 'dataMovimentacao',
                label: 'Data da movimentação',
                class: 'col-min text-center',
                formatter: value => this.formatDate(value),
                filterByFormatted: true,
                sortable: true,
            }

            const historico = {
                key: 'historico',
                label: 'Histórico',
                class: 'col-historico',
                sortable: true,
            }

            const entrada = {
                key: 'entrada',
                label: 'Entrada',
                class: 'col-min text-center',
                sortable: true,
            }

            const saida = {
                key: 'saida',
                label: 'Saída',
                class: 'col-min text-center',
                sortable: true,
            }

            const perda = {
                key: 'perda',
                label: 'Perdas',
                class: 'col-min text-center',
                sortable: true,
            }

            const estoque = {
                key: 'estoque',
                label: this.isTalidomida ? 'Estoque final' : 'Estoque',
                class: 'col-min text-center',
                sortable: true,
            }

            const numeroDocumento = {
                key: 'numeroDocumento',
                label: 'Número da documentação comprobatória',
                class: 'col-min text-center',
                sortable: true,
            }

            const numeroRegistro = {
                key: 'numeroRegistro',
                label: 'Número de registro no conselho de classe',
                class: 'col-min text-center',
                sortable: true,
            }

            if (this.isTalidomidaABase) {

                return [
                    dataMovimentacao,
                    entrada,
                    saida,
                    perda,
                    estoque,
                    numeroDocumento,
                    {
                        key: 'numeroNotificacao',
                        label: 'Número da notificação',
                        class: 'col-min text-center',
                        sortable: true,
                    },
                    {
                        key: 'pacienteDataNascimento',
                        label: 'Data de nascimento',
                        class: 'col-min text-center',
                        formatter: value => value == null ? null : this.formatDate(value),
                        filterByFormatted: true,
                        sortable: true,
                    },
                    {
                        key: 'pacienteSexo',
                        label: 'Sexo',
                        class: 'col-min text-center',
                        sortable: true,
                    },
                    {
                        key: 'medicoNome',
                        label: 'Nome',
                        sortable: true,
                    },
                    {
                        key: 'medicoCrm',
                        label: 'CRM',
                        class: 'col-min text-center',
                        sortable: true,
                    },
                    {
                        key: 'cidNome',
                        label: 'Nome',
                        class: 'col-cid-nome',
                        sortable: true,
                    },
                    {
                        key: 'cidCodigo',
                        label: 'CID',
                        class: 'col-min text-center',
                        sortable: true,
                    },
                    numeroRegistro,
                ]
            }
            else if (this.isTalidomidaEspecifico) {

                return [
                    dataMovimentacao,
                    historico,
                    entrada,
                    saida,
                    perda,
                    estoque,
                    numeroRegistro,
                    numeroDocumento,
                    {
                        key: 'observacoes',
                        label: 'Observações',
                        sortable: true,
                    },
                ]
            }
            else {

                return [
                    dataMovimentacao,
                    historico,
                    entrada,
                    saida,
                    perda,
                    estoque,
                ]
            }
        },
        isTalidomidaABase() {

            return this.isTalidomida
                && this.livroRegistroTipoId === this.enums.livroRegistroTipo.A_BASE
        },
        isTalidomidaEspecifico() {

            return this.isTalidomida
                && this.livroRegistroTipoId === this.enums.livroRegistroTipo.ESPECIFICO
        },
        isTalidomida() {

            return this.livroRegistroId === this.enums.livroRegistro.TALIDOMIDA
        }
    },
    data: () => ({
        estornoMessage: null,
        linhas: [],
        pagina: {},
        transferidoDe: null,
        transferidoPara: null,
        enums: {
            livroRegistro,
            livroRegistroTipo,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(pagina) {

            this.pagina = pagina

            this.estornoMessage = null
            this.linhas = []
            this.transferidoDe = null
            this.transferidoPara = null

            this.$refs.Modal.show()

            this.load()
        },
        load() {

            this.setLoading()

            this.repository.getLinhas(this.pagina.id)
                .then(({ data }) => {

                    this.estornoMessage = data.estornoMessage
                    this.linhas = data.linhas
                    this.transferidoDe = data.transferidoDe
                    this.transferidoPara = data.transferidoPara
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, formats],
    props: {
        repository: { type: Object, required: true },
        livroRegistroId: { type: Number, required: true },
        livroRegistroTipoId: { type: Number, default: null },
    }
}
</script>

<style scoped>
.table-movimentacoes >>> .table-movimentacoes-header-footer {
    color: var(--gray-dark);
    font-weight: 600;
    background: #f1f1f1;
    padding: 0.5rem;
    border: 1px solid #dee2e6;
}

.table-movimentacoes >>> .col-historico {
    min-width: 300px;
}

.table-movimentacoes >>> .col-cid-nome {
    min-width: 300px;
}
</style>